import type { JWTToken } from '@/types/branded';
import type { JWTPayload } from '@/types/user';

export function decodeToken(token: JWTToken): JWTPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const payload = JSON.parse(atob(parts[1]));
    return payload as JWTPayload;
  } catch {
    return null;
  }
}

export function isTokenValid(token: JWTToken | null): boolean {
  if (!token) return false;

  const payload = decodeToken(token);
  if (!payload) return false;

  const now = Date.now() / 1000;
  return payload.exp > now;
}

export function isTokenExpiringSoon(
  token: JWTToken | null,
  thresholdSeconds: number = 60
): boolean {
  if (!token) return true;

  const payload = decodeToken(token);
  if (!payload) return true;

  const now = Date.now() / 1000;
  return payload.exp - now < thresholdSeconds;
}

export function getTokenExpirationTime(token: JWTToken): number | null {
  const payload = decodeToken(token);
  if (!payload) return null;

  return payload.exp * 1000;
}
